/* global axios */
import ApiClient from './ApiClient';

class RasAPI extends ApiClient {
  constructor() {
    super('ras', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }

  getRules() {
    return axios.get(`${this.url}/rules`);
  }

  createRule(rule) {
    return axios.post(`${this.url}/rules`, { rule });
  }

  updateRule(id, rule) {
    return axios.patch(`${this.url}/rules/${id}`, { rule });
  }

  deleteRule(id) {
    return axios.delete(`${this.url}/rules/${id}`);
  }
}

export default new RasAPI();
